module.exports = __webpack_public_path__ + "img/5.cc8f7a38.png";